import { ChatCurrentlyTypingStore } from './chat-currently-typing.store';

interface SomeoneIsTypingMessage {
    userId: number;
    meetingId: number;
}

export class ChatCurrentlyTypingService {
    static $inject = ['ChatCurrentlyTypingStore', '$socket'];

    constructor(private currentlyTypingStore: ChatCurrentlyTypingStore, private $socket: any) {
        this.$socket.on('chat:typing', function (message: SomeoneIsTypingMessage) {
            currentlyTypingStore.dispatchUserIsTypingInMeeting(message.userId, message.meetingId);
        });
    }

    public tellOthersIAmTyping(meetingId: number) {
        this.$socket.emit('chat:typing', meetingId);
    }

    public usersTypingInMeeting$(meetingId: number) {
        return this.currentlyTypingStore.usersTypingInMeeting$(meetingId);
    }
}

angular.module('tradersyard').service('ChatCurrentlyTypingService', ChatCurrentlyTypingService);
